// 게임 설정값들
export const GAME_CONFIG = {

  // 이벤트명
  EVENT_ID: process.env.REACT_APP_EVENT_ID,

};


// 게임 상태 상수 정의
export const GAME_STATES = {
  // 기본 화면
  LOGIN: 'login',
  INFO_POPUP: 'infoPopup',
  HOME: 'home',
  VIDEO: 'video',
  TOUCH: 'touch',
  RANKING: 'ranking',
  ROULETTE: 'roulette',
  ROULETTE_RESULT: 'roulette_result',
  
  // 리듬 게임
  RHYTHM_GAME: 'rhythm',
  RHYTHM_RESULT: 'roundResult',
  RHYTHM_ENTRY: 'entry',
  ENTRY_FORM: 'entryForm',
  
  // 퍼즐 게임
  PUZZLE_GAME: 'puzzle',
  PUZZLE_RESULT: 'puzzleResult',
  
  // 퀴즈 게임
  QUIZ_GAME: 'quiz',
  QUIZ_RESULT: 'quizResult',
  
  // 월드컵 게임
  WORLDCUP_GAME: 'worldcup',
  WORLDCUP_RESULT: 'worldcupResult',

  // 공룡게임
  DINO_GAME: 'dino',
  DINO_RESULT: 'dinoResult',

  // 드립배틀
  DRIP_BATTLE: 'dripBattle',
  DRIP_BATTLE_RESULT: 'dripBattleResult',
  
  // 마이페이지
  MYPAGE: 'mypage'
};

// 게임별 설정 (상태 + 컬렉션 정보)
export const GAME_SETTINGS = {
  puzzle: {
    gameState: GAME_STATES.PUZZLE_GAME,
    resultState: GAME_STATES.PUZZLE_RESULT,
    resultCollection: 'puzzle_result',
    fields: ['timeSpent', 'moves', 'timeSpentMs'],
    puzzle3x3: {
      resultCollection: 'puzzle_result2',
      fields: ['timeSpent', 'moves', 'timeSpentMs']
    },
    puzzle4x4: {
      resultCollection: 'puzzle_result',
      fields: ['timeSpent', 'moves', 'timeSpentMs']
    }
  },
  quiz: {
    gameState: GAME_STATES.QUIZ_GAME,
    resultState: GAME_STATES.QUIZ_RESULT,
    resultCollection: 'quiz_result',
    fields: ['round1Answer', 'round2Answer', 'round3Answer']
  },
  worldcup: {
    gameState: GAME_STATES.WORLDCUP_GAME,
    resultState: GAME_STATES.WORLDCUP_RESULT,
    resultCollection: 'worldcup_result',
    fields: ['title', 'finalVideoId']
  },
  dino: {
    gameState: GAME_STATES.DINO_GAME,
    resultState: GAME_STATES.DINO_RESULT,
    resultCollection: 'dino_result',
    fields: ['score', 'timeSpent', 'timeSpentMs']
  },
  rhythm: {
    gameState: GAME_STATES.RHYTHM_GAME,
    resultState: GAME_STATES.RHYTHM_RESULT,
    resultCollection: 'rhythm_result',
    fields: ['score', 'maxCombo'],
    fieldMapping: {
      score: ['totalScore', 'score'],
      maxCombo: ['totalCombo', 'combo']
    }
  },
  dripBattle: {
    gameState: GAME_STATES.DRIP_BATTLE,
    resultState: GAME_STATES.DRIP_BATTLE_RESULT,
    resultCollection: 'dripBattle_result',
    fields: ['videoId', 'title']
  },
};

// 초기 상태 상수
export const INITIAL_STATE = GAME_STATES.HOME; 

// 게임 상태에서 게임 타입 추출하는 함수
export const getGameTypeFromState = (state) => {
  switch (state) {
    case GAME_STATES.RHYTHM_GAME:
    case GAME_STATES.RHYTHM_RESULT:
    case GAME_STATES.RHYTHM_ENTRY:
      return GAME_STATES.RHYTHM_GAME;

    case GAME_STATES.PUZZLE_GAME:
    case GAME_STATES.PUZZLE_RESULT:
      return GAME_STATES.PUZZLE_GAME;

    case GAME_STATES.QUIZ_GAME:
    case GAME_STATES.QUIZ_RESULT:
      return GAME_STATES.QUIZ_GAME;

    case GAME_STATES.DINO_GAME:
    case GAME_STATES.DINO_RESULT:
      return GAME_STATES.DINO_GAME;

    case GAME_STATES.WORLDCUP_GAME:
    case GAME_STATES.WORLDCUP_RESULT:
      return GAME_STATES.WORLDCUP_GAME;

    case GAME_STATES.DRIP_BATTLE:
    case GAME_STATES.DRIP_BATTLE_RESULT:
      return GAME_STATES.DRIP_BATTLE;

    default:
      return GAME_STATES.HOME;
  }
};

// 게임 타입으로 설정 가져오기
export const getGameSettings = (gameType) => {
  return GAME_SETTINGS[gameType];
};

// 게임 상태로 설정 가져오기
export const getGameSettingsByState = (state) => {
  const gameType = getGameTypeFromState(state);
  return getGameSettings(gameType);
};
